import React from "react";
import { cn } from "@/lib/utils";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const RESTOCK_STATUSES = ["Submitted", "Under Review", "Approved", "Production Planned", "In Production", "Quality Check", "Ready for Dispatch", "Dispatched", "Completed", "Rejected"];
export const KEY_STAGES = ["Submitted", "Approved", "In Production", "Quality Check", "Ready for Dispatch", "Dispatched", "Completed"];

export async function uploadFiles(fileList) {
  const out = [];
  for (const file of Array.from(fileList || [])) {
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      out.push({ url: `${process.env.REACT_APP_BACKEND_URL}${data.url}`, name: file.name });
    } catch { toast.error(`Failed to upload ${file.name}`); }
  }
  return out;
}

export function StockBadge({ status }) {
  const s = (status || "").toLowerCase();
  const map = { "in stock": "bg-success/15 text-success", "low stock": "bg-warning/15 text-warning", "out of stock": "bg-destructive/15 text-destructive" };
  const cls = map[s] || "bg-secondary text-muted-foreground";
  return <span className={cn("text-[11px] font-semibold px-2 py-0.5 rounded-full", cls)}>{status || "Unknown"}</span>;
}

export function Timeline({ current, rejected }) {
  if (rejected) return <div className="text-sm font-semibold text-destructive" data-testid="timeline-rejected">Request Rejected</div>;
  const idx = KEY_STAGES.indexOf(current);
  const eff = idx === -1 ? (RESTOCK_STATUSES.indexOf(current) >= RESTOCK_STATUSES.indexOf("Approved") ? 1 : 0) : idx;
  return (
    <div className="flex items-center gap-1 overflow-x-auto pb-1" data-testid="restock-timeline">
      {KEY_STAGES.map((st, i) => (
        <React.Fragment key={st}>
          <div className="flex flex-col items-center shrink-0">
            <div className={cn("w-6 h-6 rounded-full flex items-center justify-center text-[10px] font-bold", i <= eff ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground")}>{i + 1}</div>
            <span className={cn("text-[9px] mt-1 max-w-[64px] text-center leading-tight", i <= eff ? "text-foreground font-medium" : "text-muted-foreground")}>{st}</span>
          </div>
          {i < KEY_STAGES.length - 1 && <div className={cn("h-0.5 w-6 shrink-0", i < eff ? "bg-primary" : "bg-secondary")} />}
        </React.Fragment>
      ))}
    </div>
  );
}
